<template>
  <div class="rank-list-content">
    <div class="rank-list">
      <div class="rule-sub-title">
        <span class="square-bg"></span>
        金融机构赛道
      </div>
      <ul class="rank-list-box rank-list-box-title">
        <li class="rank-con rank-con-title">
          <span class="col1">个人信息</span>
          <span class="col2">学习热度</span>
        </li>
      </ul>
      <ul class="rank-list-box ">
        <li
          class="rank-con list-item"
          v-for="(item, index) in customRank.list"
          :key="`org${index}`"
        >
          <div class="col1">
            <p
              class="item-rank"
              :class="{ bg: item.rank_no <= 3 && item.rank_no >= 1 }"
            >
              {{ item.rank_no == 0 ? "--" : item.rank_no }}
            </p>
            <p class="item-img"><img :src="item.head" /></p>
            <div class="item-info">
              <p class="text-left ellipsis">{{ item.name }}</p>
              <p class="text-left org-name ellipsis">{{ item.org_name }}</p>
            </div>
          </div>
          <span class="col2">{{ item.score }}</span>
        </li>
        <li class="load-info">
          <span v-if="customRank.finished"
            >排行只展示前{{ customRank.maxLength }}名</span
          >
          <span class="pointer" v-else @click="customPageChange"
            >点击加载更多</span
          >
        </li>
      </ul>

      <!-- <div class="page-content" v-show="customRank.list.length > 0">
        <h-page
          :total="customRank.total"
          :current="customRank.pageNo"
          :page-size="customRank.pageSize"
          show-total
          @on-change="customPageChange"
        />
      </div> -->
    </div>
    <div class="rank-list">
      <div class="rule-sub-title">
        <span class="square-bg"></span>
        恒生电子赛道
      </div>
      <ul class="rank-list-box rank-list-box-title">
        <li class="rank-con rank-con-title">
          <span class="col1">个人信息</span>
          <span class="col2">学习热度</span>
        </li>
      </ul>
      <ul class="rank-list-box">
        <!-- <li class="rank-con rank-con-title">
          <span class="col1">个人信息</span>
          <span class="col2">学习热度</span>
        </li> -->
        <li
          class="rank-con list-item"
          v-for="(item, index) in hsRank.list"
          :key="`org${index}`"
        >
          <div class="col1">
            <p
              class="item-rank"
              :class="{ bg: item.rank_no <= 3 && item.rank_no >= 1 }"
            >
              {{ item.rank_no == 0 ? "--" : item.rank_no }}
            </p>
            <p class="item-img"><img :src="item.head" /></p>
            <div class="item-info">
              <p class="text-left ellipsis">{{ item.name }}</p>
              <p
                class="text-left ellipsis"
                v-if="uPlusUser.user_type_str != 'custom'"
              >
                {{ item.dept_name }}
              </p>
            </div>
          </div>
          <span class="col2">{{ item.score }}</span>
        </li>
        <li class="load-info">
          <span v-if="hsRank.finished"
            >排行只展示前{{ hsRank.maxLength }}名</span
          >
          <span class="pointer" v-else @click="hsPageChange">点击加载更多</span>
        </li>
      </ul>

      <!-- <div class="page-content" v-show="hsRank.list.length > 0">
        <h-page
          :total="hsRank.total"
          :current="hsRank.pageNo"
          :page-size="hsRank.pageSize"
          show-total
          @on-change="hsPageChange"
        />
      </div> -->
    </div>
    <div class="rank-list">
      <div class="rule-sub-title">
        <span class="square-bg"></span>
        机构学习之星
      </div>
      <div class="study-info" v-if="isCustomer">
        <div class="rank-con rank-con-title">
          <span class="col1 left ellipsis">{{ myOrgInfo.org_name }}</span>
          <span class="col2 rule-detail" @click="GoOrgRank"
            ><span class="info-icon"></span>查看详情</span
          >
        </div>
        <div class="info-content">
          <div class="content-item">
            <p class="num">{{ myOrgInfo.org_persons }}</p>
            <p class="info-name">机构学习人数</p>
          </div>
          <div class="content-item">
            <p class="num">
              {{
                Number(myOrgInfo.rank_no > 9999)
                  ? "9999+"
                  : myOrgInfo.rank_no || "--"
              }}
            </p>
            <p class="info-name">机构排名</p>
          </div>
        </div>
      </div>
      <ul class="rank-list-box rank-list-box-title">
        <li class="rank-con rank-con-title">
          <span class="col1">机构信息</span>
          <span class="col2">机构学习人数</span>
        </li>
      </ul>
      <ul class="rank-list-box" :class="{ ' rank-list-box-sm': isCustomer }">
        <li
          class="rank-con list-item list-item-org"
          v-for="(item, index) in orgRank.list"
          :key="`org${index}`"
        >
          <div class="col1">
            <p
              class="item-rank"
              :class="{ bg: item.rank_no <= 3 && item.rank_no >= 1 }"
            >
              {{ item.rank_no == 0 ? "--" : item.rank_no }}
            </p>
            <!-- <p class="item-img"><img :src="item.head" /></p> -->
            <div class="item-info">
              <p class="text-left ellipsis">{{ item.org_name }}</p>
            </div>
          </div>
          <span class="col2">{{ regexHandleNum(item.org_persons) }}人</span>
        </li>
        <li class="load-info">
          <span v-if="orgRank.finished"
            >排行只展示前{{ orgRank.maxLength }}名</span
          >
          <span class="pointer" v-else @click="orgPageChange"
            >点击加载更多</span
          >
        </li>
      </ul>

      <!-- <div class="page-content" v-show="orgRank.list.length > 0">
        <h-page
          :total="orgRank.total"
          :current="orgRank.pageNo"
          :page-size="orgRank.pageSize"
          show-total
          @on-change="orgPageChange"
        />
      </div> -->
    </div>

    <!--
      机构学习之星弹框-->
    <h-msg-box
      v-model="showOrganRank"
      width="700"
      :zIndex="1000"
      :mask-closable="false"
      class="rule-modal wrapper-award"
    >
      <p slot="header">
        <span class="square-bg"></span>
        <span>本机构排行详情</span>
      </p>

      <div class="rule-dialog-content rank-list">
        <div class="title">机构学习之星奖品</div>
        <p class="rule-box">
          活动结束后，机构学习人数≥100的TOP8机构的学员，将根据自己所在机构内的学习热度排行获得以下对应奖品。
        </p>
        <div class="goods-items">
          <div
            class="goods-item"
            v-for="(item, index) in giftList"
            :key="index"
          >
            <p class="goods-img"><img :src="item.img" /></p>
            <div class="goods-detail">
              <p class="goods-name">{{ item.name }}</p>
              <p class="goods-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
        <div class="title">学习排行</div>
        <p class="rule-box">
          我的学习热度: <span class="number">{{ myInfo.score || 0 }}</span
          >我在本机构排名:<span class="number">{{
            Number(myInfo.rank_no > 9999) ? "9999+" : myInfo.rank_no || "--"
          }}</span>
        </p>
        <ul class="rank-list-box rank-list-box-title">
          <li class="rank-con rank-con-title">
            <span class="col1">个人信息</span>
            <span class="col2">学习热度</span>
          </li>
        </ul>
        <ul class="rank-list-box rank-list-box-sm">
          <li
            class="rank-con list-item"
            v-for="item in myOrgRank.list"
            :key="`hsrank_${item.rank_no}`"
          >
            <div class="col1">
              <p
                class="item-rank"
                :class="{ bg: item.rank_no <= 3 && item.rank_no >= 1 }"
              >
                {{ item.rank_no == 0 ? "--" : item.rank_no }}
              </p>
              <p class="item-img"><img :src="item.head" /></p>
              <div class="item-info">
                <p class="ellipsis">{{ item.name }}</p>
                <!-- <p v-if="true || userType !== '0'">{{ item.dept_name }}</p> -->
              </div>
            </div>
            <span class="col2">{{ item.score || 0 }}</span>
          </li>
          <li class="load-info">
            <span v-if="myOrgRank.finished"
              >排行只展示前{{ myOrgRank.maxLength }}名</span
            >
            <span class="pointer" v-else @click="myOrgRankPageChange"
              >点击加载更多</span
            >
          </li>
        </ul>
        <!-- <div class="page-content" v-show="myOrgRank.list.length > 0">
          <h-page
            :total="myOrgRank.total"
            :current="myOrgRank.pageNo"
            :page-size="myOrgRank.pageSize"
            show-total
            @on-change="myOrgRankPageChange"
          />
        </div> -->
      </div>
      <div slot="footer">
        <p class="btn award-btn" @click="showOrganRank = false">知道了</p>
      </div>
    </h-msg-box>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  getRankListByOrg4ss,
  getRankList4ss,
  getMyOrgLearning4ss,
  getOrgRankList4ss,
  getMyLearningInOrg4ss
} from "@/api/uPlusApi/learning.js";
import { giftList } from "../config";
export default {
  name: "Rank",
  props: {},
  data() {
    return {
      giftList,
      showOrganRank: false,
      myInfo: {
        name: "",
        head: "",
        score: 0,
        rank_no: 0
      },
      myOrgInfo: {
        org_persons: 0,
        rank_no: "--"
      },
      hsRank: {
        pageNo: 1,
        maxLength: 100,
        total: 0,
        list: [],
        pageSize: 20,
        finished: false
      },
      customRank: {
        pageNo: 1,
        total: 0,
        maxLength: 100,
        list: [],
        pageSize: 20,
        finished: false
      },
      orgRank: {
        pageNo: 1,
        maxLength: 20,
        total: 0,
        list: [],
        pageSize: 20,
        finished: false
      },
      myOrgRank: {
        pageNo: 1,
        maxLength: 100,
        total: 0,
        list: [],
        pageSize: 20,
        finished: false
      }
    };
  },
  computed: {
    ...mapGetters(["uPlusUser"]),
    isCustomer() {
      return this.uPlusUser
        ? this.uPlusUser.user_type_str.indexOf("outerOrg") > -1
        : false;
    }
  },
  methods: {
    GoOrgRank() {
      this.GetMyOrgRank();
      this.getMyinfoInOrg();
      this.showOrganRank = true;
    },
    regexHandleNum(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 3是千分位，4是万分位
    },
    myOrgRankPageChange() {
      this.GetMyOrgRank();
    },
    customPageChange() {
      this.GetRank("custom");
    },
    hsPageChange() {
      this.GetRank("hs");
    },
    orgPageChange() {
      // this.orgRank.pageNo = index;
      this.GetRank("org");
    },

    GetRank(type) {
      if (this[`${type}Rank`].finished) {
        return;
      }
      //   debugger;
      let apiMethod = null;
      let params = {};
      if (type === "hs" || type === "custom") {
        apiMethod = getRankList4ss;
        params = {
          page_size: 20,
          rank_type: type === "hs" ? 1 : 0,
          page_no: this[`${type}Rank`].pageNo
        };
      } else if (type === "org") {
        apiMethod = getOrgRankList4ss;
        params = {
          page_size: 20
        };
      }
      apiMethod(params)
        .then(res => {
          if (!res) return;

          const resultData = res;
          const addRows = resultData.rows || [];
          const maxLen =
            resultData.total <= this[`${type}Rank`].maxLength
              ? resultData.total
              : this[`${type}Rank`].maxLength;
          this[`${type}Rank`].list = [...this[`${type}Rank`].list, ...addRows];
          ++this[`${type}Rank`].pageNo;
          if (this[`${type}Rank`].list.length >= maxLen) {
            this[`${type}Rank`].finished = true;
          }
        })
        .catch(() => {
          //   this[`${type}Rank`].error = true;
        })
        .finally(() => {
          //   this[`${type}Rank`].loading = false;
        });
    },
    GetMyOrgInfo() {
      getMyOrgLearning4ss({}).then(res => {
        if (res) {
          this.myOrgInfo = res;
        }
      });
    },
    GetMyOrgRank() {
      if (this.myOrgRank.finished) {
        return;
      }
      const params = {
        page_size: 20,
        page_no: this.myOrgRank.pageNo
      };
      getRankListByOrg4ss(params)
        .then(res => {
          if (!res) return;
          const resultData = res;
          const addRows = resultData.rows || [];
          const maxLen =
            resultData.total <= this.myOrgRank.maxLength
              ? resultData.total
              : this.myOrgRank.maxLength;
          this.myOrgRank.list = [...this.myOrgRank.list, ...addRows];
          ++this.myOrgRank.pageNo;
          if (this.myOrgRank.list.length >= maxLen) {
            this.myOrgRank.finished = true;
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getMyinfoInOrg() {
      getMyLearningInOrg4ss().then(res => {
        if (res) {
          this.myInfo = res;
        }
      });
    },
    async getMyInfo() {
      const res = await myInfo();
      // console.log(res)
      this.userInfo.name = res.nike_name;
      this.userInfo.fullName = res.customer_name;
      this.userInfo.num = res.hsid;
      this.userInfo.type =
        res.user_type === "0"
          ? "普通用户"
          : res.user_type === "1"
          ? "个人用户"
          : "企业用户";
    }
  },
  watch: {
    "uPlusUser.user_type_str": {
      handler(val) {
        // console.log(val.input)
        if (this.uPlusUser.user_type_str.indexOf("outerOrg") !== -1) {
          this.GetMyOrgInfo();
          this.getMyinfoInOrg();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.GetRank("hs");
    this.GetRank("custom");
    this.GetRank("org");
  }
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.load-info {
  text-align: center;
  padding: 4px;
  font-size: 16px;
  color: #2340b0;
}
.left{
  text-align: left;
  padding-left: 20px;
}
.rule-detail {
  width: 86px;
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 16px;
  color: #2340b0;
  display: flex;
  align-items: center;
  text-decoration: underline;
  justify-content: flex-end;
  padding-right: 20px;
  cursor: pointer;
  .info-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background: url("~@/assets/activity/learningStar/info-dark.png") 50% 50%
      no-repeat;
    background-size: contain;
  }
}
.square-bg {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #506fe9;
  border: 2px solid rgba(35, 64, 176, 1);
  margin-right: 8px;
}
.rank-list-content {
  display: flex;
  justify-content: space-between;
}
.rank-list {
  width: 366px;
  margin-top: 22px;
  .rule-sub-title {
    font-size: 20px;
    color: #2340b0;
    line-height: 1;
  }
  .rank-list-box-title {
    margin-top: 10px;
  }
  .rank-list-box {
    max-height: 605px;
    overflow-y: auto;
  }
  .rank-list-box-sm {
    max-height: 429px;
  }
  .rank-con {
    background: #ffffff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 14px;
    color: #2340b0;
    text-align: center;
    .col1 {
      flex: 1;
      width: 183px;
    }
    .col2 {
      flex: 1;
      width: 183px;
      flex-shrink: 0;
    }
  }
  .rank-con-title {
    background: #c4d0ff;
  }
  .list-item {
    height: 72px;
    padding: 16px;
    text-align: left;
    .col1 {
      display: flex;
      align-items: center;
    }
    .col2 {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 14px;
      color: #2340b0;
      letter-spacing: 0;
      text-align: center;
    }
    .item-rank {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 16px;
      color: #2340b0;
      letter-spacing: 0;
      text-align: center;
      flex-shrink: 0;
      width: 26px;
      margin-right: 4px;

      &.bg {
        background: #506fe9;
        border: 1px solid rgba(35, 64, 176, 1);
        color: #ffffff;
        border-radius: 16px;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin: 0 10px 0 4px;
      }
    }
    .item-info p {
      word-break: break-all;
      width: 100px;
    }
    .item-info p + p {
      // margin-top: 12px;
    }
    .item-info .org-name {
      font-size: 14px;
      color: #5c79e6;
      width: 100px;
    }
    .item-img {
      width: 38px;
      height: 38px;
      flex-shrink: 0;
      border-radius: 38px;
      overflow: hidden;
      background: #c4d0ff;
      border: 1px solid rgba(35, 64, 176, 1);
      margin-right: 12px;
      > img {
        width: 100%;
      }
    }
  }
  .list-item-org {
    height: 50px;
  }
}
.study-info {
  margin-top: 10px;
  border-radius: 2px;
  .rank-con-title {
    border-bottom: none;
    margin-bottom: 0;
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 116px;
    margin-bottom: 20px;
    background: #ffffff;
    border: 1px solid #2340b0;
    border-radius: 2px;
    .num {
      font-family: AlibabaPuHuiTi-Medium;
      font-size: 30px;
      color: #2340b0;
      text-align: center;
      font-weight: 500;
    }
    .info-name {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 16px;
      color: #5c79e6;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
    .content-item {
      width: 316px;
      height: 120px;
      padding: 24px;
    }
  }
}
// .page-content {
//   text-align: right;
//   margin-top: 5px;

//   /deep/ .h-page {
//     font-size: 0;
//   }
//   /deep/ .h-page-item,
//   /deep/ .h-page-item-jump-next,
//   /deep/ .h-page-item-jump-prev {
//     background: #f3f6ff;
//     border: 1px solid rgba(35, 64, 176, 1);
//     border-radius: 2.88px;
//     min-width: 36px;
//     height: 36px;
//     line-height: 36px;
//     font-size: 16px;
//     a {
//       font-size: 16px;
//       color: #2340b0;
//     }
//     &::after {
//       color: #2340b0;
//     }
//   }
//   /deep/ .h-page-item-active {
//     background: #c4d0ff;
//     border: 1px solid rgba(35, 64, 176, 1);
//     border-radius: 2.88px;
//   }
//   /deep/ .h-page-prev,
//   /deep/ .h-page-next {
//     background: #f3f6ff;
//     border: 1px solid rgba(35, 64, 176, 1);
//     border-radius: 2.88px;
//     min-width: 36px;
//     height: 36px;
//     line-height: 36px;
//     a {
//       font-size: 16px;
//       color: #2340b0;
//     }
//   }
//   /deep/ .h-page-total {
//     font-size: 16px;
//     color: #2340b0;
//     height: 36px;
//     line-height: 36px;
//     vertical-align: bottom;
//   }
//   /deep/ .h-page-disabled {
//     background-color: #f7f7f7;
//     border-color: #ccc;
//     a {
//       color: #ccc;
//     }
//   }
// }
.rule-modal {
  .award-btn {
    background: #ffd52d;
    border: 1px solid #2340b0;
    box-shadow: 1px 2px 0 0 #5c79e6, inset -2px -3px 0 0 #ff6800,
      inset 2px 2px 0 0 #ffffff;
    border-radius: 18px;
    width: 140px;
    height: 36px;
    display: flex;
    margin: 0 auto 10px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #2340b0;
    cursor: pointer;
  }
  /deep/ .h-modal-content {
    background: #dce4ff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
  }
  /deep/ .h-modal-header {
    border-bottom: none;
    padding: 10px;
    font-size: 18px;
    color: #2340b0;
    > p {
      display: flex;
      color: #2340b0;
    }
    .square-bg {
      width: 18px;
      height: 18px;
      line-height: 18px;
    }
  }
  /deep/ .h-modal-close {
    right: 10px;
    top: 10px;
  }
  /deep/ .h-modal-body {
    padding: 3px 10px 0;
    p {
      font-size: 14px;
      color: #5c79e6;
    }
  }
  /deep/ .h-modal-footer {
    border-top: none;
    text-align: center;
    padding: 10px;
  }

  .rank-tab {
    display: inline-block;
    border: 1px solid rgba(35, 64, 176, 1);
    border-bottom: 0;
    border-radius: 2px;
    height: 26px;
    align-items: center;
    // margin-bottom: 20px;
    background: #fff;
    color: #2340b0;
    li {
      display: inline-block;
      width: 100px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      cursor: pointer;
      &.active {
        background: #506fe9;
        border-radius: 2px;
        color: #ffffff;
      }
    }
    // .rank-tab-2 {
    //   width: 50%;
    // }
  }
  .rule-connect {
    font-size: 14px;
    color: #5c79e6;
  }
  .rank-content {
    background: #ffffff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
    padding: 20px;
    font-size: 14px;
    color: #5c79e6;
    height: 280px;
    overflow-y: auto;
    > p {
      color: #5c79e6;
    }
  }
}
.rule-dialog-content {
  background: #ffffff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  padding: 20px;
  width: 100%;
  max-height: 460px;
  overflow-y: auto;
  margin-top: 0;
  .rank-list-box {
    max-height: initial;
  }
  .number {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 20px;
    color: #2340b0;
    margin-right: 20px;
  }
  .list-item {
    height: 60px;
    .item-info p {
      word-break: break-all;
      width: 200px;
    }
  }
  .item-img {
    margin-left: 70px;
  }
  .goods-items {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .title {
    font-size: 14px;
    color: #2340b0;
    margin-bottom: 6px;
  }
  .goods-item {
    border-radius: 4px 0px 0px 4px;
    width: 310px;
    height: 126px;
    display: flex;
    .goods-img {
      width: 200px;
      height: 126px;
      background: #c4d0ff;
      border: 1px solid rgba(35, 64, 176, 1);
      border-radius: 2px 0px 0px 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 85%;
        max-height: 85%;
      }
    }
    .goods-detail {
      background: #f3f6ff;
      border: 1px solid rgba(35, 64, 176, 1);
      border-radius: 0px 2px 2px 0px;
      border-left: none;
      width: 110px;
      height: 126px;
    }
    .goods-name {
      font-size: 24px;
      color: #2340b0;
      font-weight: 400;
      padding-top: 32px;
      text-align: center;
    }
    .goods-desc {
      font-size: 20px;
      color: #5c79e6;
      font-weight: 400;
      padding-left: 8px;
      padding-top: 8px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/learningStar/components/Rank.vue